import type { AttachmentTranslationResponse } from '@govinity/validation';
import type {
  PublicDocumentFilterOptionsResponse,
  PublicDocumentsFullSearchBody,
  PublicDocumentsFullSearchResponse,
  PublicDocumentsGetResponse,
  PublicDocumentsSearchBody,
} from '@govinity/validation/public';

import { ReadOnlyApi } from '../base';

type PublicDocumentsSearchResponse = { count: number; records: PublicDocumentsGetResponse[] };

export class PublicDocumentsApi extends ReadOnlyApi<
  PublicDocumentsGetResponse,
  PublicDocumentsGetResponse,
  PublicDocumentsSearchBody,
  PublicDocumentsSearchResponse
> {
  private readonly governmentPath: string;
  private readonly governmentCode: string;

  constructor(governmentCode: string, governmentPath: string) {
    super();
    this.governmentPath = governmentPath;
    this.governmentCode = governmentCode;
  }

  getPath() {
    return `${this.governmentPath}/${this.governmentCode}/public-documents`;
  }

  async filterOptions(params?: { year?: string }) {
    const { data } = await this.request<PublicDocumentFilterOptionsResponse>({
      method: 'GET',
      params: params ?? {},
      url: `${this.getPath()}/filter-options`,
    });

    return data;
  }

  async search(body: PublicDocumentsSearchBody) {
    const { data } = await this.request<PublicDocumentsSearchResponse>({
      method: 'POST',
      url: this.getPath(),
      data: body,
    });

    return data;
  }

  async requestTranslation(id: number) {
    const { data } = await this.request<AttachmentTranslationResponse>({
      method: 'POST',
      url: `${this.getPath()}/${id}/translation`,
    });

    return data;
  }

  async fullSearch(body: PublicDocumentsFullSearchBody) {
    const { data } = await this.request<PublicDocumentsFullSearchResponse>({
      method: 'POST',
      url: `${this.getPath()}/full-search`,
      data: body,
    });

    return data;
  }
}
